const pageTypes = require('../constants/global').contentType;

module.exports = {
  [pageTypes.homePage]: require('./homePageQuery'),
  [pageTypes.urlBuilder]: require('./urlBuilderQuery'),
  [pageTypes.layout]: require('./layoutQuery'),
  [pageTypes.articlePage]: require('./articlePageQuery'),
  [pageTypes.articleListPage]: require('./articleListPageQuery'),
  [pageTypes.contentPage]: require('./contentPageQuery'),
  [pageTypes.siteMap]: require('./siteMapQuery'),
  [pageTypes.productListPage]: require('./productListingQuery'),
  [pageTypes.productPage]: require('./productPageQuery'),
  [pageTypes.newProductPage]: require('./newProductPageQuery'),
  [pageTypes.countrySelectorPage]: require('./countrySelectorQuery'),
  [pageTypes.registrationPage]: require('./registrationPageQuery'),
  [pageTypes.loginPage]: require('./logInPageQuery'),
  sectionContainer: require('./sectionContainerQuery'),
  siteMapWithId: require('./siteMapWithIdQuery'),
  articleAlgolia: require('./articleAlgoliaQuery'),
  productAlgolia: require('./productAlgoliaQuery'),
};
